export const AgricultureDashboardDefaultParams = {
    dashboardType: 'gis',
    pUUID: '',
    locName: '',
    locType: 'COUNTRY',
    pEUUID: '',
    location: '',
    source: '',
    view: ''
}

export const AgricultureDashboardRequiredParams = ['dashboardType', 'pUUID', 'locName', 'locType', 'pEUUID', 'location','source','view']